var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "reviewDialog",
        "header-class": "header-class-modal-doc-package",
        size: "xl",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "hide-backdrop": "",
        "ok-only": !_vm.isUpdateAndExternal,
        "ok-title": _vm.okTitleLabel,
        "ok-variant": _vm.okVariant,
        "ok-disabled": _vm.loadingForMarkReview || _vm.loadingForSubmit,
        "cancel-disabled": _vm.loadingForSubmit,
        "cancel-variant": "outline-primary",
      },
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.handleOk.apply(null, arguments)
        },
        cancel: _vm.emitEventClose,
        hidden: _vm.emitEventClose,
        close: _vm.emitEventClose,
        show: _vm.emitEventShow,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "4" } }, [
                    _vm._v(
                      "\n\t\t\t\t" + _vm._s(_vm.titleCaption) + "\n\t\t\t"
                    ),
                  ]),
                  _vm.isCreate === false && _vm.dataLength > 1
                    ? _c(
                        "b-col",
                        { staticClass: "pl-5", attrs: { cols: "4" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-center",
                            },
                            [
                              _c("div", [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn-transparent text-color-rhapsody-in-blue",
                                    attrs: {
                                      disabled:
                                        _vm.disableBtnBefore ||
                                        _vm.loadingForMarkReview ||
                                        _vm.loadingForSubmit,
                                    },
                                    on: { click: _vm.handleClickBefore },
                                  },
                                  [
                                    _c(_vm.getLucideIcon("ChevronLeft"), {
                                      tag: "component",
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-color-rhapsody-in-blue fs-16 fw-40",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.FormMSG(45, "Entry")) +
                                        " " +
                                        _vm._s(_vm.currentIndex) +
                                        " / " +
                                        _vm._s(_vm.dataLength)
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn-transparent text-color-rhapsody-in-blue",
                                    attrs: {
                                      disabled:
                                        _vm.disableBtnNext ||
                                        _vm.loadingForMarkReview ||
                                        _vm.loadingForSubmit,
                                    },
                                    on: { click: _vm.handleClickAfter },
                                  },
                                  [
                                    _c(_vm.getLucideIcon("ChevronRight"), {
                                      tag: "component",
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function ({ ok, cancel }) {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "w-100 d-flex justify-content-end align-items-center",
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-138-px mr-3",
                      attrs: {
                        size: "md",
                        variant: "custom-outline-gray",
                        disabled:
                          _vm.loadingForSubmit ||
                          _vm.loadingForRunAutomate ||
                          _vm.loadingForMarkReview,
                        block: "",
                      },
                      on: { click: cancel },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.FormMSG(43, "Cancel")) +
                          "\n\t\t\t"
                      ),
                    ]
                  ),
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "w-138-px mr-3",
                      attrs: {
                        id: "review-dialog-more-action",
                        variant: "outline-primary",
                        disabled:
                          _vm.loadingForRunAutomate ||
                          _vm.loadingForSubmit ||
                          _vm.loadingForMarkReview ||
                          _vm.loadingResetStatus,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "button-content",
                            fn: function () {
                              return [
                                _vm.loadingForRunAutomate ||
                                _vm.loadingForMarkReview ||
                                _vm.loadingResetStatus
                                  ? _c("b-spinner", { attrs: { small: "" } })
                                  : _vm._e(),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.FormMSG(189, "More")) +
                                    "\n\t\t\t\t"
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c(
                        "b-dropdown-item",
                        { on: { click: _vm.handleClickRunAutomation } },
                        [
                          _c("div", { staticClass: "d-flex" }, [
                            _c(
                              "div",
                              { staticClass: "mr-2" },
                              [
                                _c(_vm.getLucideIcon("Play"), {
                                  tag: "component",
                                  attrs: { size: 16 },
                                }),
                              ],
                              1
                            ),
                            _c("div", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.FormMSG(197, "Run automations")) +
                                  "\n\t\t\t\t\t\t"
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      !_vm.forCreate
                        ? _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: _vm.handleClickCreateCarbonTemplate,
                              },
                            },
                            [
                              _c("div", { staticClass: "d-flex" }, [
                                _c(
                                  "div",
                                  { staticClass: "mr-2" },
                                  [
                                    _c(_vm.getLucideIcon("Settings"), {
                                      tag: "component",
                                      attrs: { size: 16 },
                                    }),
                                  ],
                                  1
                                ),
                                _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.FormMSG(
                                          198,
                                          "Create new automation"
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm.showContextStatus && _vm.showResetStatusMenu
                        ? _c(
                            "b-dropdown-item",
                            { on: { click: _vm.handleClickResetStatus } },
                            [
                              _c("div", { staticClass: "d-flex" }, [
                                _c(
                                  "div",
                                  { staticClass: "mr-2" },
                                  [
                                    _c(_vm.getLucideIcon("RotateCcw"), {
                                      tag: "component",
                                      attrs: { size: 16 },
                                    }),
                                  ],
                                  1
                                ),
                                _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.FormMSG(289, "Reset status")) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm.showContextStatus && _vm.carbonData.templateId > 0
                        ? _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.handleClickViewAutomation(
                                    _vm.carbonData.templateId
                                  )
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "d-flex" }, [
                                _c(
                                  "div",
                                  { staticClass: "mr-2" },
                                  [
                                    _c(_vm.getLucideIcon("Regex"), {
                                      tag: "component",
                                      attrs: { size: 16 },
                                    }),
                                  ],
                                  1
                                ),
                                _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.FormMSG(291, "View automation")
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "w-138-px mr-3",
                      attrs: {
                        size: "md",
                        variant: _vm.okVariant,
                        disabled:
                          _vm.loadingForSubmit ||
                          _vm.loadingForRunAutomate ||
                          _vm.loadingForMarkReview,
                        block: "",
                      },
                      on: { click: ok },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-center align-items-center",
                        },
                        [
                          _vm.loadingForSubmit
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              class: `${_vm.loadingForSubmit ? "pl-2" : ""}`,
                              staticStyle: { "margin-top": "1px" },
                            },
                            [_vm._v(_vm._s(_vm.okTitleLabel))]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  !_vm.forCreate
                    ? _c(
                        "b-button",
                        {
                          staticClass: "w-300-px",
                          attrs: {
                            size: "md",
                            variant: "blue-sapphire",
                            disabled:
                              _vm.loadingForSubmit ||
                              _vm.loadingForRunAutomate ||
                              _vm.loadingForMarkReview ||
                              _vm.disableMarkReview,
                          },
                          on: { click: _vm.handleClickReviewed },
                        },
                        [
                          _vm.loadingForMarkReview === false
                            ? _c(_vm.getLucideIcon("CheckCircle"), {
                                tag: "component",
                                attrs: { size: 16 },
                              })
                            : _vm._e(),
                          _vm.loadingForMarkReview === true
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.labelMarkReview) +
                              "\n\t\t\t"
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c(
        "div",
        {
          ref: "content-review-dialog",
          attrs: { id: "content-review-dialog" },
        },
        [
          _vm.stateError.show
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            variant: "danger",
                            show: "",
                            dismissible: "",
                          },
                          on: { dismissed: _vm.handleDismissedError },
                        },
                        [
                          _c("div", {
                            domProps: { innerHTML: _vm._s(_vm.stateError.msg) },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c("div", { staticClass: "float-right" }, [
                  _c("div", { staticClass: "d-flex" }, [
                    _c("div", { staticClass: "wrap-status" }, [
                      _c(
                        "div",
                        {
                          staticClass: "status fw-700",
                          class: {
                            validated: _vm.carbonData.verified === 3,
                            "not-submitted": _vm.carbonData.verified === 0,
                            pending: _vm.carbonData.verified === 2,
                            info: _vm.carbonData.verified === 1,
                          },
                          staticStyle: { "font-size": "0.7rem" },
                        },
                        [
                          _c("div", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.getLabelVerifiedStatus(
                                    _vm.carbonData.verified
                                  )
                                ) +
                                "\n\t\t\t\t\t\t\t\t"
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "perfect-scrollbar",
            { attrs: { id: "content-review-dialog-details" } },
            [
              _c(
                "b-row",
                {
                  staticClass: "row-content-dialog-details",
                  attrs: { "align-h": "around" },
                },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "carousel-wrapper",
                      attrs: { sm: "12", md: "4", lg: "4", xl: "4" },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticStyle: { height: "100%" } },
                            [
                              _vm.imageUrls.length > 0
                                ? _c("carousel", {
                                    key: _vm.carouselImgUpd,
                                    staticStyle: {
                                      height: "100%",
                                      "justify-content": "space-between",
                                    },
                                    attrs: {
                                      value: _vm.imageUrls
                                        .map((img) => img.imgSrc)
                                        .reverse(),
                                      "num-visible": _vm.numberItemVisible,
                                      "num-scroll": _vm.numberScroll,
                                      orientation: "horizontal",
                                      verticalViewPortHeight: `100%`,
                                      contentClass: "main-carousel",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item",
                                          fn: function (slotProps) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "product-item" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "product-item-content",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "parent cursor-pointer",
                                                        },
                                                        [
                                                          _vm.getFileExtension(
                                                            slotProps.data
                                                          ) !== "pdf"
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "slide",
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-img-lazy",
                                                                    {
                                                                      staticClass:
                                                                        "px-1",
                                                                      staticStyle:
                                                                        {
                                                                          "border-radius":
                                                                            "8px",
                                                                          height:
                                                                            "100%",
                                                                        },
                                                                      attrs: {
                                                                        src: slotProps.data,
                                                                        alt: slotProps.data,
                                                                        "fluid-grow":
                                                                          "",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "iframe-pdf",
                                                                },
                                                                [
                                                                  _c("iframe", {
                                                                    staticClass:
                                                                      "full full_h clearfix",
                                                                    attrs: {
                                                                      src: slotProps.data,
                                                                      frameborder:
                                                                        "0",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  class:
                                                    _vm.getFileExtension(
                                                      slotProps.data
                                                    ) !== "pdf"
                                                      ? "child"
                                                      : "w-100",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "actions",
                                                      class:
                                                        _vm.getFileExtension(
                                                          slotProps.data
                                                        ) === "pdf"
                                                          ? "d-flex justify-content-center"
                                                          : "",
                                                    },
                                                    [
                                                      _c(
                                                        "b-button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-tooltip",
                                                              rawName:
                                                                "v-b-tooltip.hover.top",
                                                              value: {
                                                                variant:
                                                                  "primary",
                                                              },
                                                              expression:
                                                                "{ variant: 'primary' }",
                                                              modifiers: {
                                                                hover: true,
                                                                top: true,
                                                              },
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "button",
                                                            variant:
                                                              "transparent",
                                                            title: _vm.FormMSG(
                                                              61,
                                                              "Preview"
                                                            ),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.showPicture(
                                                                slotProps
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            _vm.getLucideIcon(
                                                              "Eye"
                                                            ),
                                                            {
                                                              tag: "component",
                                                              staticStyle: {
                                                                "margin-top":
                                                                  "4px",
                                                              },
                                                              attrs: {
                                                                size: 32,
                                                                "stroke-width": 2,
                                                                color:
                                                                  "#3f9b9b",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "b-button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-tooltip",
                                                              rawName:
                                                                "v-b-tooltip.hover.top",
                                                              value: {
                                                                variant:
                                                                  "danger",
                                                              },
                                                              expression:
                                                                "{ variant: 'danger' }",
                                                              modifiers: {
                                                                hover: true,
                                                                top: true,
                                                              },
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "button",
                                                            variant:
                                                              "transparent",
                                                            title: _vm.FormMSG(
                                                              60,
                                                              "Delete"
                                                            ),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.removeFile(
                                                                slotProps
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            _vm.getLucideIcon(
                                                              "Trash2"
                                                            ),
                                                            {
                                                              tag: "component",
                                                              attrs: {
                                                                size: 32,
                                                                "stroke-width": 2,
                                                                color:
                                                                  "#ea4e2c",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "b-button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-tooltip",
                                                              rawName:
                                                                "v-b-tooltip.hover.top",
                                                              value: {
                                                                variant:
                                                                  "primary",
                                                              },
                                                              expression:
                                                                "{ variant: 'primary' }",
                                                              modifiers: {
                                                                hover: true,
                                                                top: true,
                                                              },
                                                            },
                                                          ],
                                                          staticClass:
                                                            "d-flex justify-content-center align-items-center",
                                                          style: `${
                                                            _vm.imageUrls
                                                              .length > 1
                                                              ? "margin: 12px 0 8px 0"
                                                              : ""
                                                          }`,
                                                          attrs: {
                                                            variant:
                                                              "transparent",
                                                            title: _vm.FormMSG(
                                                              62,
                                                              "Add images/Files"
                                                            ),
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.onPickFile,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            _vm.getLucideIcon(
                                                              "FilePlus"
                                                            ),
                                                            {
                                                              tag: "component",
                                                              attrs: {
                                                                size: 32,
                                                                "stroke-width": 2,
                                                                color:
                                                                  "#3f9b9b",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1706113989
                                    ),
                                  })
                                : _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        height: "100%",
                                        width: "100%",
                                        "align-items": "center",
                                        "justify-content": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center align-items-center",
                                          style: `${
                                            _vm.imageUrls.length > 1
                                              ? "margin: 12px 0 8px 0"
                                              : ""
                                          }`,
                                          attrs: {
                                            size: "sm",
                                            variant: "outline-primary",
                                          },
                                          on: { click: _vm.onPickFile },
                                        },
                                        [
                                          _c(_vm.getLucideIcon("PlusCircle"), {
                                            tag: "component",
                                            attrs: {
                                              size: 16,
                                              "stroke-width": 2,
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "px-2",
                                              staticStyle: {
                                                "margin-bottom": "-2px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.FormMSG(
                                                      62,
                                                      "Add images/Files"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("input", {
                    ref: "additional-detail-file",
                    staticStyle: { display: "none" },
                    attrs: { type: "file" },
                    on: { change: _vm.onFilePicked },
                  }),
                  _c(
                    "b-col",
                    {
                      staticClass: "pb-5",
                      attrs: { sm: "12", md: "7", lg: "7", xl: "7" },
                    },
                    [
                      _c("main-detail-for-review", {
                        ref: "mainDetailReview",
                        attrs: {
                          source: _vm.sourceType,
                          "data-to-review": _vm.dataToEdit,
                          "for-create": _vm.forCreate,
                          "disable-form": _vm.disableForm,
                        },
                        on: {
                          "main-detail-for-review:change":
                            _vm.handleMainDetailForReviewChange,
                        },
                      }),
                      _c("additional-detail", {
                        attrs: {
                          title: _vm.titleAdditionalDetail,
                          source: _vm.sourceType,
                          "for-create": _vm.disableForm,
                          "data-to-review": _vm.dataToEdit,
                        },
                        on: {
                          "additional-detail:change":
                            _vm.handleAdditionalDetailChange,
                          "additional-detail:image-picked":
                            _vm.handleAdditionalDetailImagePicked,
                        },
                      }),
                      _c(
                        "fieldset",
                        {
                          staticClass: "my-0 py-0 pb-0 mt-4",
                          class: `${
                            _vm.$screen.width <= 576
                              ? "card-inside"
                              : "scheduler-border"
                          }`,
                        },
                        [
                          _c(
                            "legend",
                            {
                              staticClass:
                                "text-color-rhapsody-in-blue-2 fw-400",
                              class: `${
                                _vm.$screen.width <= 576
                                  ? "card-inside"
                                  : "scheduler-border"
                              }`,
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.titleGreenDetail) +
                                  "\n\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "pt-3 pb-4" },
                            [
                              _c("co-two-clap", {
                                ref: "coTwoClapRef",
                                attrs: {
                                  "parent-id": _vm.entityId,
                                  "entity-type": _vm.sourceType,
                                  "for-create": !_vm.isEditMode,
                                  "is-submit": _vm.submitCarbon,
                                  "external-data": _vm.dataForCarbon,
                                  "external-carbon-data": _vm.carbonData,
                                  "disable-transport-forms":
                                    _vm.disableTransportForms,
                                  "disable-accomodation-forms":
                                    _vm.disableAccomodationForms,
                                  "disable-waste-forms": _vm.disableWasteForms,
                                  "disable-carbon-type-selector":
                                    _vm.disableCarbonSelector,
                                  "use-address-transport-string":
                                    _vm.useAddressTransportString,
                                  "hide-distance-known-transport":
                                    _vm.hideDistanceKnownForExpenseMileage,
                                  "hide-location-selector":
                                    _vm.hideLocationSelector,
                                  "hide-premise-menu": false,
                                },
                                on: {
                                  "co-two-clap:reviewed":
                                    _vm.handleClickReviewed,
                                  "co-two-clap:init-carbon":
                                    _vm.handleCoTwoClapInitCarbon,
                                  "co-two-clap:change":
                                    _vm.handleCoTwoClapChange,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm.forCreate === false &&
                      _vm.dataToEdit.verified === false
                        ? _c(
                            "b-row",
                            { staticClass: "mt-3" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "pl-4 pr-4",
                                      attrs: {
                                        variant: "primary",
                                        disabled:
                                          _vm.loadingForMarkReview ||
                                          _vm.loadingForSubmit,
                                      },
                                      on: { click: _vm.handleClickReviewed },
                                    },
                                    [
                                      _vm.loadingForMarkReview === false
                                        ? _c(_vm.getLucideIcon("CheckCircle"), {
                                            tag: "component",
                                            attrs: { size: 16 },
                                          })
                                        : _vm._e(),
                                      _vm.loadingForMarkReview === true
                                        ? _c("b-spinner", {
                                            attrs: { small: "" },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.FormMSG(48, "Mark as reviewed")
                                          ) +
                                          "\n\t\t\t\t\t\t\t"
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("capture-images", {
                    ref: "capture-images",
                    attrs: {
                      multiple: "",
                      "preview-mode": "button",
                      pictures: _vm.imageUrls,
                      "preview-modal-options": {
                        zIndex: 1041,
                        hideLikeDislike: true,
                        hideCommentButton: true,
                        hideDisLikeButton: true,
                      },
                      "dispatch-event-add-action": true,
                    },
                    on: { change: _vm.handleImgsTaken },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("carbon-template-dialog", {
            attrs: {
              open: _vm.showCarbonTemplateDialog,
              "data-to-edit": _vm.carbonTemplateData,
              "raw-text-data": _vm.rawTextAutomation,
            },
            on: {
              "carbon-template-dialog:close":
                _vm.handleCarbonTemplateDialogClose,
              "carbon-template:submit-success":
                _vm.handleCarbonTemplateSubmitSuccess,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }